import uuid from 'uuidv4';
import { Block, cloneBlock } from '@chameleoncreator/creator-app';

export const createBlock = (
  type: string,
  children: Block[] = [],
  extra: any = {}
): Block => {
  //
  let meta;
  const packageVersion = process.env.PACKAGE_VERSION;

  if (extra.meta) {
    meta = extra.meta;
    if (
      meta &&
      ['module', 'topic', 'interaction'].includes(type?.toLowerCase())
    ) {
      meta.packageVersion = packageVersion;

      // console.log(
      //   'TYPE :',
      //   type,
      //   'HAS UPDATED META WITH PACKAGE_VERSION :',
      //   packageVersion
      // );
    }
  }

  return {
    id: uuid(),
    type: type,
    props: extra.props,
    meta,
    animator: extra.animator,
    children: children,
  };
};

const reorder = (list: any[], startIndex: number, endIndex: number): any[] => {
  const reordered = [...list];
  const [removed] = reordered.splice(startIndex, 1);
  reordered.splice(endIndex, 0, removed);

  return reordered;
};

export const reorderChildren = (
  block: Block,
  startIndex: number,
  endIndex: number
): Block => {
  if (Array.isArray(block.children)) {
    const newBlock = cloneBlock(block);
    newBlock.children = reorder(block.children, startIndex, endIndex);
    return newBlock;
  }
  return block;
};
